import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { OFFER_ANCHOR, formattedPrice } from '../utils/checkout';
export function StickyCTABar() {
  const [visible, setVisible] = useState(false);
  const price = formattedPrice();
  useEffect(() => {
    const hero = document.getElementById('top');
    const footer = document.getElementById('site-footer');
    let pastHero = false;
    let footerVisible = false;
    const update = () => setVisible(pastHero && !footerVisible);
    const heroObserver = new IntersectionObserver(([entry]) => {
      pastHero = !entry.isIntersecting;
      update();
    }, {
      threshold: 0
    });
    const footerObserver = new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting;
      update();
    }, {
      threshold: 0
    });
    if (hero) heroObserver.observe(hero);
    if (footer) footerObserver.observe(footer);
    return () => {
      heroObserver.disconnect();
      footerObserver.disconnect();
    };
  }, []);
  return <AnimatePresence data-id="element-271" data-mp="lyk1k18kzktk">
      {visible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 flex h-16 items-center justify-between gap-3 border-t border-white/10 bg-brand-navy px-4 shadow-lg md:hidden" data-id="element-272" data-mp="lxh9hpzivcc2">
          <p className="flex min-w-0 items-center gap-3" data-id="element-273" data-mp="30zbwrxzsi7w">
            {price && <span className="shrink-0 text-2xl font-extrabold leading-none text-white" data-id="element-274" data-mp="3le6ws80z2s0w">{price}</span>}
            <span className="flex min-w-0 flex-col" data-id="element-275" data-mp="3qbpaebpxpvf8">
              <span className="truncate text-sm font-extrabold leading-tight text-white" data-id="element-276" data-mp="3qae1xyljnzhs">MUSIQUE PRÊTE</span>
              <span className="truncate text-[11px] text-white/70" data-id="element-277" data-mp="3bhkg7vfoin4o">10 tomes + 5 bonus inclus</span>
            </span>
          </p>
          <a href={OFFER_ANCHOR} className="inline-flex min-h-[44px] shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-brand-gold px-4 text-[11px] font-extrabold tracking-wide text-brand-navy transition-colors duration-150 ease-out hover:bg-brand-gold-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-278" data-mp="2x9xvnyuqjmwi">
            VOIR L’OFFRE
            <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-279" data-mp="3g8tmd07dxj5l" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}